module.exports = "<div fxLayout='row' fxFlex='100'>\n  <md-icon *ngIf=\"checkIfFromArtis\" svgIcon='ic_search_white_24px.svg' class=\"navLinks search-icon\"></md-icon>\n  <md-input-container>\n    <input md-input type=\"search\" id=\"search\" placeholder=\"{{ placeholder }}\" (search)=\"emitInput($event)\" (keyup)=\"emitInput($event)\" [(ngModel)]='initVal'>\n  </md-input-container>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/searchbar/searchbar.component.html
// module id = ./src/app/shared/searchbar/searchbar.component.html
// module chunks = main